export class ScanLoadCancelledError extends Error {
  constructor() {
    super('Scan load cancelled');
    this.name = 'ScanLoadCancelledError';
  }
}

export function isScanLoadCancelledError(error: unknown): boolean {
  return error instanceof ScanLoadCancelledError;
}
